import React, { useState } from 'react'
import useTitle from 'utils/customHook/useTitle'
import i18n from 'simple-react-i18n'
import CollectivityForm from './CollectivityForm'
import { useParams } from 'react-router'
import EntityPanel from './EntityPanel'
import { Grid2 } from '@mui/material'
import useActions from 'utils/customHook/useActions'
import { getYear } from 'utils/DateUtil'
import { groupBy, maxBy } from 'lodash'
import { shallowEqual, useSelector } from 'react-redux'
import UpdatePanel from 'components/updatePanel/UpdatePanel'
import UpdateEntityPanel from './UpdateEntityPanel'
import moment from 'moment'

const CollectivityDescriptiveApp = () => {
    const {
        collectivityProps,
    } = useSelector(store => ({
        collectivityProps: store.CollectivityReducer.collectivity,
    }), shallowEqual)

    const { id } = useParams()
    const [readMode, setReadMode] = useState(true)
    const [collectivity, setCollectivity] = useState(collectivityProps)

    useTitle(() => [{
        title: 'RPQS',
        href: 'rpqs',
    }, {
        title: getYear(collectivityProps.dateEnd) || `${i18n.year} ${i18n.unknown}`,
        href: `collectivity/rpqs/${id}`,
    }, {
        title: collectivityProps.name || i18n.unknown,
        href: `collectivity/rpqs/${id}`,
    }, {
        title: i18n.descriptive,
        href: `collectivity/rpqs/${id}/description`,
    }], [collectivityProps])

    useActions(() => {
        if (readMode) {
            return {
                new: () => {},
                delete: () => {},
                export: () => {},
                edit: () => setReadMode(false),
            }
        }
        return {
            cancel: () => {
                setCollectivity(collectivityProps)
                setReadMode(true)
            },
            save: () => {
                setCollectivity(prev => ({ ...prev, updateDate: moment() }))
                setReadMode(true)
            },
        }
    }, [readMode])

    const collectivityYear = getYear(collectivity.dateEnd)
    const groupByYearManagementEntities = groupBy(collectivity.managementEntities, ({ dateEnd }) => getYear(dateEnd))
    const nbManagementEntities = collectivity?.managementEntities?.length
    const lastUpadatedEntity = collectivity.managementEntities && maxBy(collectivity.managementEntities, 'updateDate')

    return (
        <div style={{ marginTop: '10px', marginRight: '10px' }}>
            <Grid2 container columnSpacing={2}>
                <Grid2 container direction={'column'} size={9} rowSpacing={2}>
                    <Grid2>
                        <CollectivityForm
                            collectivity={collectivity}
                            readMode={readMode}
                            nbManagementEntities={nbManagementEntities}
                            setCollectivity={setCollectivity}
                        />
                        {/* Other collectivity form */}
                    </Grid2>
                    <Grid2>
                        <EntityPanel
                            year={collectivityYear}
                            managementEntities={groupByYearManagementEntities[collectivityYear]}
                        />
                    </Grid2>
                </Grid2>
                <Grid2 container direction={'column'} size={3} rowSpacing={2}>
                    <Grid2 size={12}>
                        <UpdatePanel
                            updateLogin={collectivity.updateLogin}
                            updateDate={collectivity.updateDate}
                        />
                    </Grid2>
                    {lastUpadatedEntity &&
                        <Grid2 size={12}>
                            <UpdateEntityPanel
                                entityName={lastUpadatedEntity.name}
                                updateLogin={lastUpadatedEntity.updateLogin}
                                updateDate={lastUpadatedEntity.updateDate}
                            />
                        </Grid2>
                    }
                </Grid2>
            </Grid2>
        </div>
    )
}

export default CollectivityDescriptiveApp